import axios from "axios";
import api from "@/plugins/api/EntryPoint";

export default {
  link(payload) {
    return axios.post(
      process.env.VUE_APP_API_ENDPOINT_URL + "donora-follow-link",
      payload,
      api.getHeaders()
    );
  },
};
